export const isEmpty = (str: string): boolean => str.trim().length === 0;

/** Join all non-empty strings in array */
export const joinCompact = (strings: string[], separator = "\n"): string =>
  strings.filter((s) => !isEmpty(s)).join(separator);
